/*
 * Tooltip warm-up: the first tooltip waits half a second so passing the mouse over icons does not flash labels.
 * Once one has shown, the next ones show at once, until the mouse has been off every icon for a second.
 */
const WAIT_MS = 500;
const COOL_MS = 1000;

export function startTooltipWarmup(): void {
  const page = document.documentElement;
  let warmTimer: number | undefined;
  let coolTimer: number | undefined;
  const tipOf = (target: EventTarget | null) => (target instanceof Element ? target.closest("[data-tip]") : null);

  document.addEventListener("pointerover", (e) => {
    if (!tipOf(e.target)) return;
    window.clearTimeout(coolTimer);
    if (!page.classList.contains("tips-warm")) {
      warmTimer = window.setTimeout(() => page.classList.add("tips-warm"), WAIT_MS);
    }
  });
  document.addEventListener("pointerout", (e) => {
    if (!tipOf(e.target) || tipOf(e.relatedTarget)) return;
    window.clearTimeout(warmTimer);
    coolTimer = window.setTimeout(() => page.classList.remove("tips-warm"), COOL_MS);
  });
}
